import EventMlt from "./EventMlt.js";
import useGetFormContext from "./useFormEventMltComplete"
import ScheduleEventMltComplete from "./ScheduleEventMltComplete.js";
import GuestsEventMltComplete from "./GuestsEventMltComplete.js";
import SummaryEventMltComplete from "./SummaryEventMltComplete.js"
import HistoryEventMlt from "./HistoryEventMlt.js";

const FormInputs = () => {

    const { page } = useGetFormContext()

    const display = {
        0: <EventMlt />,
        1: <ScheduleEventMltComplete />,
        2: <GuestsEventMltComplete />,
        3: <SummaryEventMltComplete />,
        4: <HistoryEventMlt />,
    }

    const content = (
        <>
            {display[page]}
        </>
    )

    return content
}
export default FormInputs